import PropTypes from "prop-types";
import { PureComponent } from "react";
import ProgressiveImg from "app/pages/.shared/ProgressiveImg.jsx";
import Paragraphs from "../../../.shared/Paragraphs.jsx";
import "./Restaurant.scss";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";

const RESTAURANT_MEDIA_SIZES = {
	small: { width: 768 },
	medium: { width: 978 },
	large: { height: 208, width: 581 },
	xlarge: { height: 208, width: 581 },
};

class Restaurant extends PureComponent {
	render() {
		const { name, paragraphs = [], photo = {} } = this.props;

		return (
			<div className="restaurant">
				<Typography
					variant={TYPOGRAPHY_VARIANTS.LARGE}
					isBold
					className="restaurant__label"
					component="h3"
				>
					{name}
				</Typography>
				{photo.url && (
					<div className="restaurant__image">
						<ProgressiveImg
							sizes={RESTAURANT_MEDIA_SIZES}
							src={photo.url}
							alt={photo.alt}
							thumbnail={photo.thumbnail}
						/>
					</div>
				)}
				<div className="restaurant__intro">
					<Paragraphs paragraphs={paragraphs} enableHTMLFormatting={true} />
				</div>
			</div>
		);
	}
}

Restaurant.propTypes = {
	name: PropTypes.string,
	paragraphs: PropTypes.arrayOf(PropTypes.string),
	photo: PropTypes.shape({
		small: PropTypes.string,
		medium: PropTypes.string,
		large: PropTypes.string,
		thumbnail: PropTypes.string,
	}),
};

export default Restaurant;
